function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "\\u30B0\\u30EB\\u30FC\\u30D7_24530",
  "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 24530",
  transform: "translate(-335 -16)"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u30B0\\u30EB\\u30FC\\u30D7_24437",
  "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 24437",
  transform: "translate(335 18)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "\\u9577\\u65B9\\u5F62_13617",
  "data-name": "\\u9577\\u65B9\\u5F62 13617",
  width: 24,
  height: 2,
  fill: "#a59785"
}), /*#__PURE__*/React.createElement("rect", {
  id: "\\u9577\\u65B9\\u5F62_13618",
  "data-name": "\\u9577\\u65B9\\u5F62 13618",
  width: 24,
  height: 2,
  transform: "translate(0 9)",
  fill: "#a59785"
}), /*#__PURE__*/React.createElement("rect", {
  id: "\\u9577\\u65B9\\u5F62_13619",
  "data-name": "\\u9577\\u65B9\\u5F62 13619",
  width: 24,
  height: 2,
  transform: "translate(0 18)",
  fill: "#a59785"
})), /*#__PURE__*/React.createElement("rect", {
  id: "\\u9577\\u65B9\\u5F62_12495",
  "data-name": "\\u9577\\u65B9\\u5F62 12495",
  width: 24,
  height: 24,
  transform: "translate(335 16)",
  fill: "none"
}));

var SvgIconMenuHamburger = function SvgIconMenuHamburger(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconMenuHamburger, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_menu_hamburger.76b0d5e2.svg";
export { ForwardRef as ReactComponent };